import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  noAccess: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100vh'
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(6, 10),
    alignItems: 'center',
    marginTop: '20vh'
  }
}));

export default useStyles;
